
  import { ChevronDownIcon } from 'vue-feather-icons'

  export default {
    name: "Select",
    props: {
      value: {
        default: null,
        required: true
      },
      options: {
        default: [],
        required: false
      },
      optionTextValue: {
        default: '',
        required: false
      },
      optionTextConcat: {
        default: '',
        required: false
      },
      optionValue: {
        default: '',
        required: true
      },
      optionKeyValue: {
        default: '',
        required: true
      }
    },
    components: {
      ChevronDownIcon
    }
  }
